/*------------------------------------*\
    MODULES
\*------------------------------------*/
import ClientsGrid from './modules/clients-grid';
import Collapse from 'bootstrap/js/dist/collapse';
import HomeHero from './modules/home-hero';
import ImageCarousel from './modules/image-carousel';
import JSConfetti from 'js-confetti';
import Konami from 'konami';
import Modal from './modules/modal';
import Nav from './modules/nav';
import ReadMore from './modules/read-more';
import Share from './modules/share';
import ShareEmail from './modules/share-email';
import StickyHeader from './modules/sticky-header';
import TypeMate from 'typemate';

/*------------------------------------*
    APP
\*------------------------------------*/
const app = {

    init() {
        this.noJs();
        this.alwaysLoad();
        this.bind();
    },

    bind() {

        // Load any items that need modules
        let modulePlaceHolders = [...document.querySelectorAll('[data-module]')];

        // No modules so bail
        if (!modulePlaceHolders.length) {
            return;
        }

        modulePlaceHolders.map((item) => {

            // Attempt to load any modules
            let modules = item.getAttribute('data-module');

            if (!modules.length) {
                return false;
            }

            // Split the modules into an array
            modules = modules.trim().split(',');

            // Loop and bind to relevant modules
            modules.map((module) => {


                switch (module.trim()) {
                    case 'clients-grid':

                        let clientsGridInstance = new ClientsGrid(item);

                        clientsGridInstance.init();

                        break;


                    case 'home-hero':

                        let homeHeroInstance = new HomeHero(item);

                        homeHeroInstance.init();

                        break;

                    case 'image-carousel':

                        let imageCarouselInstance = new ImageCarousel(item);

                        imageCarouselInstance.init();

                        break;

                    case 'modal':

                        let ModalInstance = new Modal(item);

                        ModalInstance.init();

                        break;

                    case 'nav':

                        let navInstance = new Nav(item);

                        navInstance.init();

                        break;

                    case 'read-more':

                        let readMoreInstance = new ReadMore(item);

                        readMoreInstance.init();

                        break;

                    case 'share':

                        let shareInstance = new Share(item);

                        shareInstance.init();

                        break;

                    case 'share-email':

                        let shareEmailInstance = new ShareEmail(item);

                        shareEmailInstance.init();

                        break;

                    case 'sticky-header':

                        let stickyHeaderInstance = new StickyHeader(item);

                        stickyHeaderInstance.init();

                        break;
                }
            });
        });
    },

    alwaysLoad() {
        // Typemate
        const typeMateInstance = new TypeMate(document.body, {
            selector: 'h1, h2, h3, p'
        });
        typeMateInstance.apply();

        // Konami easter egg
        const jsConfetti = new JSConfetti();

        const easterEgg = new Konami(() => {
            jsConfetti.addConfetti({
                confettiColors: [
                    '#FF4D00', '#A3A3A3', '#0A0A0A'
                ],
                confettiNumber: 1000,
            });
        });
    },

    noJs() {
        document.documentElement.classList.remove('no-js');
        document.documentElement.classList.add('js');
    }
};

// Launch
app.init();
